<template>
  <div class="tree-select">
    <el-popover
      style="min-width: 200px; width: 100%"
      placement="bottom-start"
      popper-class="tree-select-popover fine-scroll-bar"
      trigger="click"
      @show="isShow = true"
      @hide="isShow = false"
    >
      <el-input
        readonly
        class="tree-select-reference"
        size="small"
        slot="reference"
        @mouseenter.native="isClear = Boolean(selectStr.length)"
        @mouseleave.native="isClear = false"
        v-model="selectStr"
        placeholder="请选择"
      >
        <i
          slot="suffix"
          style="width: 25px; font-size: 14px; line-height: 28px"
          v-if="!isShow && !isClear"
          class="el-icon-arrow-down"
        ></i>
        <i
          slot="suffix"
          style="width: 25px; font-size: 14px; line-height: 28px"
          v-if="isShow && !isClear"
          class="el-icon-arrow-up"
        ></i>
        <i
          slot="suffix"
          style="
            width: 25px;
            font-size: 14px;
            line-height: 28px;
            cursor: pointer;
          "
          v-if="isClear"
          class="el-icon-circle-close"
          @click.stop="deleteData"
        ></i>
      </el-input>
      <div>
        <!-- 搜索输入框 -->
        <el-input
          style="width: 100%; margin-bottom: 10px"
          size="small"
          v-model="searchText"
          placeholder="请输入搜索关键字"
          @keyup.enter.native="search"
          class="tree-select-interior"
        >
          <el-button
            size="small"
            slot="append"
            icon="el-icon-search"
            @click="search"
          ></el-button>
        </el-input>
        <!-- 树形控件 -->
        <div class="tree-box fine-scroll-bar">
          <VueEasyTree
            class="virtual-tree"
            height="300px"
            :default-expanded-keys="defaultExpend"
            ref="tree"
            nodeKey="codeValue"
            :data="treeData"
            :props="treeProps"
            show-checkbox
            lazy
            :load="loadNode"
            @check="handleClick"
            :expand-on-click-node="false"
            :check-on-click-node="true"
            :check-strictly="false"
            @check-change="handleCheckChange"
          ></VueEasyTree>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import {
  subRegionList,
  continentList,
  searchregion,
} from '@/utils/api/customer.js'
// import VueEasyTree from '@wchbrad/vue-easy-tree'
import VueEasyTree from '@/components/tree-virtual/components/ve-tree.vue'
export default {
  props: {},
  components: {
    VueEasyTree,
  },
  data() {
    return {
      isShow: false,
      isClear: false,
      selectStr: '',
      searchText: '', // 搜索关键字
      treeData: [], // 树形展示的数据
      treeProps: {
        label: 'name', // 节点的标签名字，展示在树形控件中
        children: 'children', // 子节点数组，每个节点都有一个children数组，用于渲染子节点
        // isLeaf: 'isLeaf', // 是否为叶子节点，用于判断是否需要动态加载子节点
        disabled: 'disabled', // 是否禁用节点
        checked: 'checked', // 当前节点是否选中
        isLeaf: (data, node) => {
          // 是否显示展开
          return !data.leaf
        },
        nodeKey: 'codeValue',
      },
      loading: false, // 搜索结果加载状态
      checkedKeys: [], // 搜索结果中所有已选中的节点的value值
      defaultExpend: [], // 默认展开的数组
      defaultChecked: [], // 默认勾选的数组
      values: [], // 选中结果
      loading: false,
    }
  },
  methods: {
    // 动态加载节点的子节点
    loadNode(node, resolve) {
      // 如果node为0，代表是初始化触发，直接return掉
      if (node.level === 0) return
      // 加载子级数据，获取当前国家下所有省份节点数据
      this.getChild(node, (provinces) => {
        node.data.children = provinces
        resolve(provinces)
      })
    },

    // 获取子节点数据
    async getChild(node, callback) {
      try {
        const res = await subRegionList(node.data.codeValue, node.data.subType)
        const bizCode = res.rspResult.bizCode

        if (bizCode === 200) {
          const data = res.rspListData.list
          callback(data)
        }
      } catch(err) {
        console.error("❌ ~ file: TreeSelect.vue:151 ~ getChild ~ err:", err)
      }
    },

    // 根据搜索框内容进行搜索
    async search() {
      // 调用后端API搜索数据，并更新树形控件展示的数据
      try {
        const keyword = this.searchText.trim()

        // 如果值为空或纯空格，不让提交
        if (!keyword) return this.$message.error('关键字不能为空')

        const tree = this.$refs.tree
        const treeList = tree.getCheckedNodes()

        // 先去洲列表里面去找
        const item = this.treeData.find((item) => {
          return item.name.toLowerCase() === keyword
        })
        if (item) {
          if(treeList.some(ele => ele.codeValue === item.codeValue)) {
            return this.$message.error('已选中当前区域')
          }
          item.children = null
          return this.setExpendOrCheckd([item])
        }

        this.loading = true

        const res = await searchregion(keyword)
        const { rspListData, rspResult } = res
        if (rspResult.bizCode === 200) {
          // 首先判断返回的数组是不是为空
          if (!rspListData.list.length) {
            this.$message.error('没有找到相关区域')
            return (this.loading = false)
          }

          const result = []
          
          // 判断如果已选中数组里包含当前搜索的父级或者当前搜索的元素本身，如果包含则不做再次选中操作！
          let repeatRule = true
          rspListData.list.forEach((item) => {
            // 当前元素的父级是否已选中
            const parentSome = treeList.some((ele) =>
              this.rulesIsChecked(ele, item)
            )
            // 当前元素是否已选中
            const itemSome = treeList.some(
              (ele) => ele.codeValue === item.codeValue
            )
            // 如果当前搜索结果在已选中列表不存在 并且 它的父级也不存在，就放行
            if (!parentSome && !itemSome) {
              result.push(item)
              repeatRule = false
            }
          })
          if (repeatRule) return this.$message.error('已选中当前区域')

          // 根据搜索结果更新树形结构
          this.setExpendOrCheckd(result)
        } else {
          this.loading = false
        }
      } catch (err) {
        console.error("❌ ~ file: TreeSelect.vue:217 ~ search ~ err:", err)
      }
    },

    // 校验当前元素的父元素有没有被选中
    rulesIsChecked(item, data) {
      // 如果符合，直接return
      if (item.codeValue === data.codeValue) {
        return true
      }
      // 如果没有children了，代表是最后一层了，那就没有选中的父元素，直接放行
      if (!data.children?.length) {
        return false
      }
      return this.rulesIsChecked(item, data.children[0])
    },

    // 设置展开或选中
    setExpendOrCheckd(arr) {
      arr.forEach((ele) => {
        if (ele.children?.length) {
          // 这个时候代表有子分支，展开当前项
          this.defaultExpend.push(ele.codeValue)
          // 拿自己的子分支集合再去调用自己
          this.setExpendOrCheckd(ele.children)
        } else {
          const tree = this.$refs.tree
          // 根据实时的勾选清空重新获取；
          // this.defaultChecked = tree.getCheckedKeys()
          // 没有子分支代表是最后一级，直接选中即可
          this.defaultChecked.push(ele.codeValue)
          this.$refs.tree.setCheckedKeys(this.defaultChecked)
          // 将已选中的值转为字符串渲染在输入框
          this.setCheckedValueStr()
          this.loading = false
        }
      })
    },

    // 根据当前选中的值生成字符串，用于外部input展示用
    handleSelectStr(arr) {
      let str = ''
      arr.forEach((item, index) => {
        str = str + item.name + ','
      })
      str = str.slice(0, str.length - 1)
      return str
    },

    // 点击选择或取消选择时触发
    handleClick(data, node) {
      const tree = this.getsimpleTree(this.$refs.tree)
      // 拿到缩减后的node集合
      this.values = tree.checkedNodesId
      this.defaultChecked = tree.checkedNodesId
      // 将结果emit出去用来搜索
      this.$emit('checkChange', this.values, tree.checkedNodes)
      // 将选中结果转为字符串拼接
      this.selectStr = this.handleSelectStr(tree.checkedNodes)
    },

    // 将已选中的值缩减，只拿父元素
    getsimpleTree(setstore) {
      const checkedNodes = []
      const checkedNodesId = []
      const traverse = function (node) {
        const childNodes = node.root ? node.root.childNodes : node.childNodes
        childNodes.forEach((child) => {
          if (child.checked) {
            checkedNodes.push(child.data)
            checkedNodesId.push(child.data.codeValue)
          }
          if (child.indeterminate) {
            traverse(child)
          }
        })
      }
      traverse(setstore.store)
      return {
        checkedNodes,
        checkedNodesId,
      }
    },

    // 选中的节点发生了变化
    handleCheckChange() {},

    // 点击清空
    deleteData() {
      this.isClear = false
      this.selectStr = ''
      this.defaultChecked = []
      this.values = []
      this.searchText = ''
      const tree = this.$refs.tree
      this.treeData.forEach((ele) => {
        tree.setChecked(ele, false, true)
      })
      this.$emit('checkChange', [], [])
    },

    // 恢复上次搜索的选择项
    recoverArea(ids, notes) {
      const tree = this.$refs.tree
      tree.getCheckedKeys().forEach((ele) => {
        tree.setChecked(ele, false)
      })
      ids.forEach((ele) => {
        tree.setChecked(ele, true, true)
      })
      this.selectStr = this.handleSelectStr(notes)
    },

    setCheckedValueStr() {
      // TODO 这里后续看有没有更好的解决方案，延时器不太好
      setTimeout(() => {
        // 拿到缩减后的node集合
        const tree = this.getsimpleTree(this.$refs.tree)
        this.values = tree.checkedNodesId
        // 将结果emit出去用来搜索
        this.$emit('checkChange', this.values, tree.checkedNodes)
        // 将选中结果转为字符串拼接
        this.selectStr = this.handleSelectStr(tree.checkedNodes)
        this.defaultChecked = this.$refs.tree.getCheckedKeys()
      }, 500)
    },
  },

  async created() {
    try {
      // 当浏览器里面有，优先从浏览器里面取
      if (localStorage.getItem('treeData')) {
        return this.$nextTick(() => {
          this.treeData = JSON.parse(localStorage.getItem('treeData'))
        })
      }
      const res = await continentList()
      if (res.rspResult.bizCode === 200) {
        this.$nextTick(() => {
          this.treeData = res.rspListData.list.map((ele) => ({
            ...ele,
            children: ele.leaf ? [] : undefined,
            loading: false,
          }))
          localStorage.setItem('treeData', JSON.stringify(this.treeData))
        })
      }
    } catch(err) {
      console.error("❌ ~ file: TreeSelect.vue:363 ~ created ~ err:", err)
    }
  },

  mounted() {},
}
</script>

<style lang="scss" scoped>
::v-deep .el-checkbox__inner,
.el-tree-node__expand-icon {
  transition: none !important;
  &::after {
    transition: none !important;
  }
}

/* 关闭选中和展开CSS动画 */
::v-deep .el-tree-node__content,
.el-tree-node__children,
.el-tree-node__expand-icon {
  transition: none !important;
}
.tree-select {
  &-popover {
    max-height: 400px;
    overflow: auto;
    .el-input-group__append:last-of-type {
      .el-button {
        background: #066eb7;
        border-color: #066eb7;
        color: #fff;
      }
    }
    ::v-deep .el-input__inner {
      color: #16181a;
      font-size: 12px !important;
    }
    .tree-select-interior {
      input {
        border-radius: 4px 0 0 4px;
      }
      .el-input-group__append {
        width: 32px;
        button {
          border-radius: 0 4px 4px 0;
          height: 32px;
        }
      }
    }
    ::v-deep .collapse-transition {
      transition: none !important;
    }
  }
  &-reference {
    width: 240px !important;
    @media screen and (max-width: 1400px) {
      width: 190px !important;
    }
    @media screen and (max-width: 1200px) {
      width: 150px !important;
    }
  }
  .tree-select-reference {
  }
  .el-input__suffix {
    .el-input__suffix-inner {
      i {
        line-height: 32px !important;
      }
    }
  }
  ::v-deep .el-input__inner {
    color: #16181a;
    font-size: 12px;
  }
}
::v-deep .virtual-tree .vue-recycle-scroller {
  @import '@/assets/css/common.scss';
  @include fine-scroll-bar;
  min-width: 300px;
  max-width: 400px;
  width: 100%;
  min-height: 200px;
  max-height: 300px;
  height: auto !important;
  .vue-recycle-scroller__item-wrapper {
    /* width: auto; */
    overflow: visible;
  }
  .vue-recycle-scroller__item-view {
    /* width: auto; */
    /* white-space: pre; */
  }
}
</style>
